module.exports = __webpack_public_path__ + "static/media/logoMin.f03fe7cd.svg";